import { InputText } from "primereact/inputtext";
import extractDataFromMap from "../../utils/ExtractDataFromMap";
import { Password } from "primereact/password";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { format as dateFnsFormat, parse } from "date-fns";
import { Calendar } from "primereact/calendar";
import { InputSwitch } from "primereact/inputswitch";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import assignDataToMap from "../../utils/AssignDataToMap";
import ZirvuFileManagerButton from "../../components/zirvu-file-manager/ZirvuFileManagerInput";
import { InputTextarea } from "primereact/inputtextarea";

const genElText = ({
  field,
  name,
  data,
  setData,
  disabled,
  autoFocus,
  error,
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <InputText
        id={field}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        autoFocus={autoFocus}
        value={value}
        disabled={disabled}
        autoComplete="off"
        onChange={(e) => {
          const newData = { ...data };
          assignDataToMap({ key: field, value: e.target.value, map: newData });
          setData(newData);
        }}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElTextArea = ({
  field,
  name,
  data,
  setData,
  disabled,
  autoFocus,
  error,
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <InputTextarea
        id={field}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        autoFocus={autoFocus}
        value={value}
        disabled={disabled}
        autoComplete="off"
        onChange={(e) => {
          const newData = { ...data };
          assignDataToMap({ key: field, value: e.target.value, map: newData });
          setData(newData);
        }}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElTextPassword = ({
  field,
  name,
  data,
  setData,
  disabled,
  autoFocus,
  error,
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <Password
        id={field}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        autoFocus={autoFocus}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const newData = { ...data };
          assignDataToMap({ key: field, value: e.target.value, map: newData });
          setData(newData);
        }}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElTextDropdown = ({
  field,
  name,
  data,
  setData,
  options,
  disabled,
  autoFocus,
  error,
  optionLabel = "name",
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <Dropdown
        id={field}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        options={options}
        optionLabel={optionLabel}
        autoFocus={autoFocus}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const newData = { ...data };
          assignDataToMap({ key: field, value: e.value, map: newData });
          setData(newData);
        }}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElNumber = ({
  field,
  name,
  data,
  setData,
  min_fraction_digits,
  max_fraction_digits,
  min,
  max,
  disabled,
  autoFocus,
  error,
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <InputNumber
        id={field}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        autoFocus={autoFocus}
        value={value}
        disabled={disabled}
        locale="id-ID"
        showButtons
        buttonLayout="horizontal"
        minFractionDigits={min_fraction_digits ? min_fraction_digits : 0}
        maxFractionDigits={max_fraction_digits ? max_fraction_digits : 0}
        min={min ? min : -999999999999}
        max={max ? max : 999999999999}
        onChange={(e) => {
          const newData = { ...data };
          assignDataToMap({ key: field, value: e.value, map: newData });
          setData(newData);
        }}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElNumberDropdown = ({
  field,
  name,
  data,
  setData,
  options,
  disabled,
  autoFocus,
  error,
  optionLabel = "name",
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <Dropdown
        id={field}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        options={options}
        optionLabel={optionLabel}
        autoFocus={autoFocus}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const newData = { ...data };
          assignDataToMap({ key: field, value: e.value, map: newData });
          setData(newData);
        }}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElBoolean = ({
  field,
  name,
  data,
  setData,
  labelTrue = "Ya",
  labelFalse = "Tidak",
  disabled,
  autoFocus,
  error,
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <div className="row-start-center gap-2">
        <InputSwitch
          className={`${error[field] ? "bg-red-100" : ""}`}
          id={field}
          autoFocus={autoFocus}
          checked={value > 0 ? true : false}
          onChange={(e) => {
            const newData = { ...data };
            assignDataToMap({
              key: field,
              value: e.value ? 1 : 0,
              map: newData,
            });
            setData(newData);
          }}
        />
        {value > 0 ? labelTrue : labelFalse}
      </div>

      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElDate = ({
  field,
  name,
  data,
  setData,
  primeFormat,
  min,
  max,
  showTime,
  time,
  month,
  year,
  disabled,
  autoFocus,
  error,
}) => {
  const propValue = extractDataFromMap({ key: field, map: data }) ?? "";

  let value = null;
  if (propValue && propValue !== null) {
    if (propValue.length === 10) {
      value = parse(propValue, "yyyy-MM-dd", new Date());
    } else if (propValue.length === 16) {
      value = parse(propValue, "yyyy-MM-dd HH:mm", new Date());
    } else {
      value = parse(propValue, "yyyy-MM-dd HH:mm:ss", new Date());
    }
  }

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <Calendar
        id={field}
        disabled={disabled}
        autoFocus={autoFocus}
        value={value ?? null}
        showIcon
        showButtonBar
        minDate={min}
        maxDate={max}
        dateFormat={primeFormat ?? "dd/mm/yy"}
        showTime={showTime}
        hourFormat="24"
        timeOnly={time}
        view={month ? "month" : year ? "year" : "date"}
        onChange={(e) => {
          const jsDate = e.value;
          if (jsDate && jsDate !== null) {
            const formattedDate = dateFnsFormat(jsDate, "yyyy-MM-dd HH:mm:ss");

            const newData = { ...data };
            assignDataToMap({ key: field, value: formattedDate, map: newData });
            setData(newData);
          } else {
            const newData = { ...data };
            assignDataToMap({ key: field, value: null, map: newData });
            setData(newData);
          }
        }}
        className={`w-full ${error[field] ? "bg-red-100" : ""}`}
        locale="id"
      />

      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const genElObject = ({
  name,
  field,
  value,
  onClick,
  onClear,
  disabled,
  autoFocus,
  width,
  error = {},
}) => {
  return (
    <div className={`col-start-start gap-1 ${width ?? "w-full"}`}>
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <div className="row-start-center gap-1 w-full">
        <Button
          disabled={disabled}
          className={`bg-indigo-50 border-indigo-100 w-full text-slate-700 ${
            error[field] ? "bg-red-100" : ""
          }`}
          outlined
          onClick={(e) => {
            e.preventDefault();
            if (onClick) {
              onClick();
            }
          }}
        >
          <div className="row-between-center w-100">
            {!value || value.length < 0 ? "-" : value}
            <i className="pi pi-search" />
          </div>
        </Button>
        {onClear && (
          <Button
            className="bg-red-400 border-red-400 max-w-[1.8rem] max-h-[1.8rem]"
            icon="pi pi-times"
            rounded
            severity="danger"
            onClick={(e) => {
              e.preventDefault();
              if (onClear) {
                onClear();
              }
            }}
          />
        )}
      </div>
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

const GenElZirvuFileManager = ({
  field,
  name,
  data,
  setData,
  disabled,
  autoFocus,
  error,
}) => {
  const value = extractDataFromMap({ key: field, map: data }) ?? "";
  const [valueState, setValueState] = useState(value);

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return (
    <div className="col-start-start w-100 gap-1">
      <label htmlFor={field} className="font-bold text-sm text-slate-500">
        {name}
      </label>
      <ZirvuFileManagerButton
        disabled={disabled}
        width="100%"
        height="200px"
        value={valueState}
        onSelect={(event, newValue) => {
          const newData = { ...data };

          if (newValue && newValue.url !== null) {
            assignDataToMap({ key: field, value: newValue.url, map: newData });
          } else {
            assignDataToMap({ key: field, value: null, map: newData });
          }
          setData(newData);
        }}
      />
      {error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

export {
  genElText,
  genElTextArea,
  genElTextPassword,
  genElTextDropdown,
  genElNumber,
  genElNumberDropdown,
  genElBoolean,
  genElDate,
  genElObject,
  GenElZirvuFileManager as genElZirvuFileManager,
};
